import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import { resolveTenantSlug, stripTenantPrefix } from '@barber/ui';
import './index.css';

/**
 * Ponto de entrada.
 *
 * O prefixo `/b/:slug` é consumido ANTES do router: ele identifica a barbearia
 * em `localhost` e não é uma rota do app. Deixá-lo na URL obrigaria toda rota a
 * existir duas vezes — `/agendar` e `/b/alfa/agendar` — e o primeiro `<Link>`
 * escrito sem lembrar disso levaria o cliente para fora da barbearia.
 *
 * `replaceState` em vez de `pushState`: o slug já foi guardado, e voltar para
 * ele com o botão do navegador não deveria virar um passo do histórico.
 */
/** Padrão de build, para quem roda o app sem informar a barbearia na URL. */
const SLUG_PADRAO = import.meta.env['VITE_TENANT_SLUG'] as string | undefined;

const slug = resolveTenantSlug(window.location.pathname, SLUG_PADRAO);
const semPrefixo = stripTenantPrefix(window.location.pathname);

if (slug && semPrefixo !== window.location.pathname) {
  window.history.replaceState(null, '', `${semPrefixo}${window.location.search}`);
}

const root = document.getElementById('root');

if (!root) throw new Error('Elemento #root não encontrado no index.html.');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
